import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import Tab from './tab';

class Tabs extends React.PureComponent {
    static propTypes = {
        newsTitle: PropTypes.array,
        tabs: PropTypes.array,
        children: PropTypes.any,
    };

    state = {
        current: 0,
    };

    handleMouseOver = e => {
        const index = Number(e.currentTarget.getAttribute('index'));

        if (index !== this.state.current) {
            this.setState({
                current: index,
            });
        }
    };

    renderTabHead = () => {
        const { newsTitle, tabs } = this.props;

        return (
            <NoSSR>
                <Chip
                    id="50058"
                    type="struct"
                    title="要闻区中栏标题"
                    groupName="要闻区中栏"
                    content={newsTitle}
                    position="relative">
                    <Tab tabs={tabs} handleMouseOver={this.handleMouseOver} />
                </Chip>
            </NoSSR>
        );
    };

    renderBody() {
        return (
            <div className={styles.tabBody}>
                {React.Children.map(this.props.children, (item, index) =>
                    React.cloneElement(item, { active: this.state.current === index }),
                )}
            </div>
        );
    }

    /**
     * 渲染组件
     */
    render() {
        return (
            <div id="tabs">
                {this.renderTabHead()}
                {this.renderBody()}
            </div>
        );
    }
}

export default errorBoundary(Tabs);
